import { useContext, useState } from "react";

import { OspToast } from "@ospweb/sdk-ui";
import { useParams } from "next/navigation";
import { ROUTER_PATH } from "@config/router";
import Translations from "@translate/hooks/useShare";
import { I18nUtil } from "@utils/i18n";
import { OspApiClientContext } from "@features/api/client/OspApiClientProvider";

const I18n = I18nUtil.createScoped(Translations);

const SITE_URL = process.env.NEXT_PUBLIC_SITE_UR;

export const useShare = (props?: { chatId?: string }) => {
  const [selected, setSelected] = useState<string[]>([]);
  const { chatApi } = useContext(OspApiClientContext);
  const { chatId } = useParams() || {};
  const [loading, setLoading] = useState(false);
  const [showSelect, setShowSelect] = useState(false);

  const getShareUrl = async ({
    selected,
    type,
  }: {
    selected: string[];
    type?: string;
  }) => {
    setLoading(true);
    try {
      const res = await chatApi?.share.shareCreate({
        ids: selected,
        chatId: props?.chatId || (chatId as string),
      });
      setLoading(false);
      if (res?.data.data) {
        const shareUrl = `${SITE_URL}${ROUTER_PATH.CHAT_SHARE}/${res?.data.data.shareId}${type ? `?type=${type}` : ""}`;
        return shareUrl;
      }
      OspToast.error({
        content: I18n.t("Share failed"),
      });
      return "";
    } catch (error) {
      setLoading(false);
      OspToast.error({
        content: I18n.t("Share failed"),
      });
      return "";
    }
  };

  return {
    selected,
    setSelected,
    loading,
    showSelect,
    setShowSelect,
    getShareUrl,
  };
};
